import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import { AllegroIsHereText } from "../../../shared";
import GetStartedButton from "src/components/shared/components/getStartedButton";

const AllegroIsHere = () => {
  return (
    <Column spacingInset={"none none none 500"} height="100%" heights={["2em"]}>
      <Row></Row>
      <Row widths={["grid-5", "grid-5"]}>
        <Row></Row>
        <Column spacing="none">
          <Column spacingInset={"600 600 500 none"}>
            <AllegroIsHereText fontType={"d100"}></AllegroIsHereText>
          </Column>
          <GetStartedButton
            targetElement={"heresHowItWorksElement"}
          ></GetStartedButton>
        </Column>
      </Row>
    </Column>
  );
};

export default AllegroIsHere;
